export default "__VITE_ASSET__9Gmc8B____"